<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :width="dialogWidth" :scrollable="true">
      <v-card>
        <v-card-title class="headline">{{$t('prizesDialog.title')}}</v-card-title>
        <v-card-text>
          <span>{{$t('prizesDialog.description')}}</span>
          <prizes-widget v-model="prizes"/>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" text @click="accept()">
            <v-icon left>mdi-check</v-icon>{{$t('common.take-over')}}
          </v-btn>
          <v-btn color="error" text @click="cancelDialog()">
            <v-icon left>mdi-close-circle</v-icon>{{$t('common.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// import { ACTION_LOAD_FRIENDS } from "@/plugins/store";
import PrizesWidget from "./PrizesWidget"

export default {
  name: "PrizesDialog",
  components: {
    PrizesWidget,
  },
  props: {
    value: Array,
    visible: {
      type: Boolean,
      required: true
    },
    closeAction: {
      type: Function,
      required: true
    },
    acceptAction: {
      type: Function,
      required: false
    }
  },
  data: function() {
    return {
      dialog: false,
      prizes: []
    };
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "600";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "80%";
      }
      return "90%";
    }
  },
  watch: {
    visible: function(val) {
      // console.log('visible changed to ' + val)
      this.dialog = val;
    },
    dialog: function(val) {
      // console.log("dialog changed to " + val);
      if (val === false) {
        this.closeAction();
      }
    },
    value: function(val) {
      // console.log("value changed to", val);
      this.overtakePrizes(val)
    },
  },
  mounted() {
    this.dialog = this.visible;
    this.overtakePrizes(this.value)
  },
  methods: {
    overtakePrizes(prizes) {
      prizes = prizes ? prizes : []
      let newPrizes = []
      prizes.forEach(element => {
        newPrizes.push(element)
      });
      this.prizes = newPrizes;
      // console.log("overtook "+this.prizes.length+" prizes");
    },
    accept() {
      // console.log("emitting "+this.prizes.length+" prizes");
      this.$emit("input", this.prizes);
      this.dialog = false;
      this.acceptAction && this.acceptAction(this.prizes);
    },
    cancelDialog() {
      this.reset()
      this.closeAction();
    },
    reset() {
      this.overtakePrizes(this.value)
    }
  }
};
</script>
<style scoped>
</style>